import { QueryKeys } from "@/constants/Query";
import { useApi } from "@/hooks/useApi";
import axiosInstance from "@/lib/axios";

export interface DispositionOption {
  code: string;
  label: string;
  defaultValue?: string;
}
interface DispositionCodesResponse {
  dispositionCodes: DispositionOption[];
}

export const useDispositionCodes = () => {
  return useApi<DispositionCodesResponse>({
    queryOptions: {
      enabled: true,
      queryFn: async () => {
        const response = await axiosInstance.get<DispositionCodesResponse>(
          "/charting/careplan/disposition/codes",
        );

        return response.data;
      },
      queryKey:
        QueryKeys.Patient.Chart.EpisodesOfCare.CarePlan.Disposition.CODES,
      staleTime: Number.POSITIVE_INFINITY,
    },
  });
};
